import { z } from 'zod';

export const worldlineConfigSchema = z.object({
  /** References `location._id` */
  tenantId: z.string(),
  apiKey: z.string(),
  apiSecret: z.string(),
  merchantId: z.string(),
  webhookKey: z.string(),
  webhookSecret: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type WorldlineConfig = z.output<typeof worldlineConfigSchema>;

export const worldlineConfigCvxSchema = worldlineConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type WorldlineConfigCvx = z.output<typeof worldlineConfigCvxSchema>;
